module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-toc",
    attrs: {
      "id": "table-of-contents"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title case-upper"
  }, [_vm._v("CONTENTS")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-contents text"
  }, [_c('div', {
    staticClass: "toc-frontmatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/introduction"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Introduction")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-bodymatter-group"
  }, [_c('div', {
    staticClass: "toc-group toc-group-volume"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-volume toc-item-element-container-group has-no-leading-number has-no-author has-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/vol001"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Was it Good For You Too?")])])])]), _vm._v(" "), _c('div', {
    staticClass: "item-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/vol001acknowledgementsandgratitude"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Acknowledgements and Gratitude")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/vol001chapter001"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 1")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/vol001chapter002"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 2")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/vol001chapter003"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 3")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/vol001chapter004"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 4")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/vol001chapter005"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 5")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/vol001chapter006"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 6")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/vol001chapter007"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 7")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/vol001chapter008"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 8")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/vol001chapter009"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 9")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/vol001chapter010"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 10")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol001chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 11")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol001chapter012",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 12")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol001chapter013",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 13")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol001chapter014",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 14")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol001chapter015",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 15")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol001chapter016",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 16")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol001chapter017",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 17")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol001chapter018",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 18")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol001chapter019",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 19")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol001chapter020",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 20")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol001chapter021",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 21")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol001chapter022",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 22")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol001chapter023",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 23")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol001chapter024",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 24")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol001chapter025",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 25")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol001chapter026",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 26")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol001chapter027",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 27")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol001chapter028",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 28")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol001chapter029",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 29")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol001chapter030",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 30")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol001chapter031",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 31")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol001chapter032",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 32")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol001chapter033",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 33")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol001chapter034",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 34")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol001chapter035",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 35")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol001epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Epilogue")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol001authorsreflectiononchicagovocationalschool",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Author’s Reflection on Chicago Vocational School")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-group toc-group-volume"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-volume toc-item-element-container-group has-no-leading-number has-no-author has-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol002",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Open Door Marriage")])])])]), _vm._v(" "), _c('div', {
    staticClass: "item-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol002acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Acknowledgments")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol002chapter001",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 1")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol002chapter002",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 2")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol002chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 3")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol002chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 4")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol002chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 5")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol002chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 6")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol002chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 7")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol002chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 8")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol002chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 9")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol002chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 10")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol002chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 11")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol002chapter012",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 12")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol002chapter013",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 13")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol002chapter014",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 14")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol002chapter015",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 15")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol002chapter016",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 16")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol002chapter017",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 17")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol002chapter018",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 18")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol002chapter019",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 19")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol002chapter020",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 20")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol002chapter021",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 21")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol002chapter022",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 22")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol002chapter023",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 23")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol002chapter024",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 24")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol002chapter025",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 25")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol002chapter026",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 26")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol002chapter027",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 27")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol002chapter028",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 28")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol002chapter029",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 29")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol002chapter030",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 30")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol002chapter031",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 31")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol002chapter032",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 32")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol002chapter033",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 33")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol002chapter034",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 34")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol002chapter035",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 35")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol002chapter036",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 36")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol002chapter037",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 37")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol002chapter038",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 38")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol002chapter039",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 39")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol002chapter040",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 40")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol002chapter041",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 41")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol002chapter042",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 42")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-group toc-group-volume has-grandchildren"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-volume toc-item-element-container-group has-no-leading-number has-no-author has-children has-grandchildren"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Rich Woman’s Fetish")])])])]), _vm._v(" "), _c('div', {
    staticClass: "item-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Acknowledgments")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003quotefrommaewest",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Quote from Mae West")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-group toc-group-part"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-part toc-item-element-container-group has-no-leading-number has-no-author has-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part001",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Part I")])])])]), _vm._v(" "), _c('div', {
    staticClass: "item-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part001prologue",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Prologue")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part001chapter001",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 1")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part001chapter002",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 2")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part001chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 3")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part001chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 4")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part001chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 5")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part001chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 6")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part001chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 7")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part001chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 8")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003quotefrommarilynmonroe",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Quote from Marilyn Monroe")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-group toc-group-part"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-part toc-item-element-container-group has-no-leading-number has-no-author has-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part002",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Part II")])])])]), _vm._v(" "), _c('div', {
    staticClass: "item-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part002chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 9")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part002chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 10")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part002chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 11")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part002chapter012",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 12")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part002chapter013",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 13")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part002chapter014",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 14")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part002chapter015",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 15")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003quotefromrobertfrost",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Quote from Robert Frost")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-group toc-group-part"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-part toc-item-element-container-group has-no-leading-number has-no-author has-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part003",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Part III")])])])]), _vm._v(" "), _c('div', {
    staticClass: "item-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part003chapter016",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 16")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part003chapter017",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 17")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part003chapter018",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 18")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part003chapter019",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 19")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part003chapter020",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 20")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part003chapter021",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 21")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part003chapter022",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 22")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part003chapter023",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 23")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003quotefromdouglasadams",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Quote from Douglas Adams")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-group toc-group-part"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-part toc-item-element-container-group has-no-leading-number has-no-author has-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part004",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Part IV")])])])]), _vm._v(" "), _c('div', {
    staticClass: "item-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part004chapter024",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 24")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part004chapter025",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 25")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part004chapter026",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 26")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part004chapter027",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 27")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part004chapter028",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 28")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part004chapter029",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 29")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part004chapter030",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 30")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part004chapter031",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 31")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part004chapter032",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 32")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part004chapter033",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 33")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part004chapter034",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 34")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part004chapter035",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 35")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part004chapter036",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 36")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part004chapter037",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 37")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part004chapter038",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 38")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part004chapter039",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 39")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part004chapter040",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 40")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part004chapter041",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 41")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part004chapter042",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 42")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part004chapter043",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 43")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part004chapter044",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 44")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part004chapter045",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 45")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003part004chapter046",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Chapter 46")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003kingofdurabia",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("King of Durabia")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003queenoflahaina",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Queen of Lahaina")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003sugaraintsosweet",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Sugar Ain’t So Sweet")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003lovingmeforme",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Loving Me for Me")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003thepleasuresallmine",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("The Pleasure’s All Mine")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003mytimeinthesun",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("My Time in the Sun")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003queensofthecastleseries",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Queens of the Castle Series")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003kingsofthecastle",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Kings of the Castle")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003knightsofthecastle",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Knights of the Castle")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/vol003abouttheauthor",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("About the Author")])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 60
// module chunks = 0